import { Button } from '@/web/components/ui/button';
import { useTranslation } from '@/shared/web/i18n/LanguageProvider';
import { GoogleIcon } from './GoogleIcon';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

/** Stateless — the parent owns what "sign in" means. */
export function GoogleSignInButton({ onClick, disabled, label = 'Continue with Google' }: Props) {
  const { t } = useTranslation();
  return (
    <Button
      type="button"
      variant="secondary"
      size="lg"
      className="squircle w-full"
      onClick={onClick}
      disabled={disabled}
    >
      <GoogleIcon data-icon="inline-start" />
      {t(label)}
    </Button>
  );
}
